import { useEffect } from "react";
import "@/App.css";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Servizi from "@/pages/Servizi";
import Formazione from "@/pages/Formazione";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Prenota from "@/pages/Prenota";
import Scadenziario from "@/pages/Scadenziario";
import Contatti from "@/pages/Contatti";
import AreaAssistiti from "@/pages/AreaAssistiti";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <HashRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/formazione" element={<Formazione />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/prenota" element={<Prenota />} />
            <Route path="/scadenziario" element={<Scadenziario />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/area-assistiti" element={<AreaAssistiti />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </HashRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
